import type { FC, PropsWithChildren } from "react";
import React from "react";

import cn from "classnames";

import { getChildrenRecord } from "../../../utils/react";

import type {
    PropsWithCustomVarsStyles,
    PropsWithTsId,
} from "../../../types/react";

import classes from "./ContentsView.styl";

export interface IContentsView {}

export const CONTENTS_VIEW_DISPLAY_NAME = "ContentsView";
export const CONTENTS_VIEW_TEST_ID = "contents-view-test-id";

export type ContentsViewProps = PropsWithChildren<IContentsView> &
    PropsWithCustomVarsStyles &
    Partial<PropsWithTsId>;

/**
 * Контейнер, который нужен для отображения нескольких компонентов ContentsView.Content (Content), регулирует отступы между ними, так же можно управлять внутренними оступами
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/💠-Base-Components?node-id=2-106061&t=i9KoZkQn1PFd13wW-1" target="_blank">Спека</a>
 * @constructor
 */
export const ContentsView: FC<ContentsViewProps> = (props) => {
    const { children, customVarsStyles, "data-tsid": tsid } = props;

    const expandedChildren = getChildrenRecord(
        children,
        CONTENTS_VIEW_DISPLAY_NAME,
        {
            Unknown: {
                skipElement: true,
            },
        },
        {
            isArrayResult: true,
        },
    );

    const contentsViewStyles = cn(classes["container"], customVarsStyles);

    return (
        <div
            className={contentsViewStyles}
            data-tsid={tsid || CONTENTS_VIEW_TEST_ID}
            data-uikit={CONTENTS_VIEW_DISPLAY_NAME}
        >
            {expandedChildren}
        </div>
    );
};

ContentsView.displayName = CONTENTS_VIEW_DISPLAY_NAME;

export default ContentsView;
